import {
  Container,
  Box,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
  FormControlLabel,
  Divider,
  Checkbox,
  SelectChangeEvent,
  IconButton
} from '@mui/material'
import { ChangeEvent, useRef } from 'react'
import { FormsProps } from '../../types'
import { QuestionMark } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { isEmpty, isNil, map } from 'lodash/fp'
import { format } from 'date-fns/fp'
import { CommonAddressForm } from '../CommonAddressForm'

const FAQ_URL =　'https://katene.chuden.jp/clubkatene/p/faq/faq_detail.html?faq_id=8026&category_id=&page_id=10000'

const listBirthYear = (): number[] => {
  const list = []
  for (let index = 1900; index < Number(format('yyyy')(Date.now())); index++) {
    list.push(index)
  }
  return list
}

export const RequestForm = (props: FormsProps) => {
  const { register, setters, formData, errors } = props

  const {
    setLastName,
    setFirstName,
    setLastNameKana,
    setFirstNameKana,
    setPostalCode,
    setPref,
    setCity,
    setTown,
    setPlace,
    setPhone,
    setEmail,
    setBarthYear,
    setBarthMonth,
    setGender,
    setGas,
    setKateneMailMagazine,
    setTokutokuMailMagazine,
    setCustomerNumber,
    setUnknownCustomerNumber,
    setPayment,
    setPaymentNumber,
    setContractorName,
    setContractorNameKana,
    setContractorPostalCode,
    setContractorPhone,
    setAgree,
    setCovenant,
    setCouponCode
  } = setters

  const lastNameRef = useRef<HTMLInputElement>(null)
  const firstNameRef = useRef<HTMLInputElement>(null)
  const lastNameKanaRef = useRef<HTMLInputElement>(null)
  const firstNameKanaRef = useRef<HTMLInputElement>(null)
  const phoneRef = useRef<HTMLInputElement>(null)
  const emailRef = useRef<HTMLInputElement>(null)
  const barthYearRef = useRef<HTMLInputElement>(null)
  const barthMonthRef = useRef<HTMLInputElement>(null)
  const genderRef = useRef<HTMLInputElement>(null)
  const gasRef = useRef<HTMLInputElement>(null)
  const kateneMailMagazineRef = useRef<HTMLInputElement>(null)
  const tokutokuMailMagazineRef = useRef<HTMLInputElement>(null)
  const customerNumberRef = useRef<HTMLInputElement>(null)
  const unknownCustomerNumberRef = useRef<HTMLInputElement>(null)
  const paymentRef = useRef<HTMLInputElement>(null)
  const paymentNumberRef = useRef<HTMLInputElement>(null)
  const contractorNameRef = useRef<HTMLInputElement>(null)
  const contractorNameKanaRef = useRef<HTMLInputElement>(null)
  const contractorPostalCodeRef = useRef<HTMLInputElement>(null)
  const contractorPhoneRef = useRef<HTMLInputElement>(null)
  const couponCodeRef = useRef<HTMLInputElement>(null)

  const {
    lastName,
    firstName,
    lastNameKana,
    firstNameKana,
    postalCode,
    pref,
    city,
    town,
    place,
    phone,
    email,
    barthYear,
    barthMonth,
    gender,
    gas,
    kateneMailMagazine,
    tokutokuMailMagazine,
    customerNumber,
    unknownCustomerNumber,
    payment,
    paymentNumber,
    contractorName,
    contractorNameKana,
    contractorPostalCode,
    contractorPhone,
    couponCode,
    kateneId,
    agree,
    covenant
  } = formData

  const handleChangeLastName = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setLastName)) {
      return
    }
    setLastName(event.currentTarget.value)
  }
  const handleChangeFirstName = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setFirstName)) {
      return
    }
    setFirstName(event.currentTarget.value)
  }
  const handleChangeLastNameKana = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setLastNameKana)) {
      return
    }
    setLastNameKana(event.currentTarget.value)
  }
  const handleChangeFirstNameKana = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setFirstNameKana)) {
      return
    }
    setFirstNameKana(event.currentTarget.value)
  }
  const handleChangePhone = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setPhone)) {
      return
    }
    setPhone(event.currentTarget.value)
  }
  const handleChangeEmail = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setEmail)) {
      return
    }
    setEmail(event.currentTarget.value)
  }
  const handleChangeBarthYear = (event: SelectChangeEvent<string>) => {
    if (isNil(setBarthYear)) {
      return
    }
    setBarthYear(event.target.value)
  }
  const handleChangeBarthMonth = (event: SelectChangeEvent<string>) => {
    if (isNil(setBarthMonth)) {
      return
    }
    setBarthMonth(event.target.value)
  }
  const handleChangeGender = (event: SelectChangeEvent<string>) => {
    if (isNil(setGender)) {
      return
    }
    setGender(event.target.value)
  }
  const handleChangeGas = (event: SelectChangeEvent<string>) => {
    if (isNil(setGas)) {
      return
    }
    setGas(event.target.value)
  }
  const handleChangeKateneMailMagazine = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (isNil(setKateneMailMagazine) || isNil(setTokutokuMailMagazine)) {
      return
    }
    setKateneMailMagazine(event.currentTarget.checked)
    if (!event.currentTarget.checked) {
      setTokutokuMailMagazine(false)
    }
  }
  const handleChangeTokutokuMailMagazine = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (isNil(setTokutokuMailMagazine)) {
      return
    }
    setTokutokuMailMagazine(event.currentTarget.checked)
  }

  const handleChangeCustomerNumber = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setCustomerNumber)) {
      return
    }
    setCustomerNumber(event.currentTarget.value)
  }
  const handleChangeUnknownCustomerNumber = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (isNil(setUnknownCustomerNumber)) {
      return
    }
    setUnknownCustomerNumber(event.currentTarget.checked)
    setCustomerNumber('')
    if (paymentRef.current?.value === 'unknown') {
      if (isNil(setPayment)) {
        return
      }
      setPayment('')
    }
  }
  const handleChangePayment = (event: SelectChangeEvent) => {
    if (isNil(setPayment)) {
      return
    }
    setPayment(event.target.value)
    if (event.target.value === 'unknown') {
      setPaymentNumber('')
    }
    return
  }
  const handleChangePaymentNumber = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setPaymentNumber)) {
      return
    }
    setPaymentNumber(event.currentTarget.value)
  }
  const handleChangeContractorName = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setContractorName)) {
      return
    }
    setContractorName(event.currentTarget.value)
  }
  const handleChangeContractorNameKana = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (isNil(setContractorNameKana)) {
      return
    }
    setContractorNameKana(event.currentTarget.value)
  }
  const handleChangeContractorPostalCode = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (isNil(setContractorPostalCode)) {
      return
    }
    setContractorPostalCode(event.currentTarget.value)
  }
  const handleChangeContractorPhone = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (isNil(setContractorPhone)) {
      return
    }
    setContractorPhone(event.currentTarget.value)
  }
  const handleChangeAgree = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setAgree)) {
      return
    }
    setAgree(event.currentTarget.checked)
  }
  const handleChangeCovenant = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setCovenant)) {
      return
    }
    setCovenant(event.currentTarget.checked)
  }
  const handleChangeCuponCode = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setCouponCode)) {
      return
    }
    setCouponCode(event.currentTarget.value)
  }
  const handleQuestionClick = () => {
    window.open(FAQ_URL, '_blank', 'noopener,noreferrer')
  }
  return (
    <Container sx={{ pt: 5 }}>
      <Typography variant="caption" color="primary">
        * 箇所は入力必須項目です。
      </Typography>
      <Box component="form" sx={{ mt: 1 }}>
        <Typography
          align="left"
          variant="h4"
          sx={{
            borderLeft: 20,
            borderBottom: 1,
            borderColor: 'orange',
            paddingLeft: 1
          }}>
          見守る方（ご契約者さま）
        </Typography>
        <Typography variant="caption">
          今回テラシテをご契約いただくお客さまの情報をご入力ください。
        </Typography>
        <Typography variant="subtitle1">
          <Typography component={'span'} color="red">
            *
          </Typography>
          <Typography component={'span'} sx={{ ml: 1 }}>
            お名前（漢字）
          </Typography>
        </Typography>
        <Stack spacing={3} direction="row" useFlexGap>
          <TextField
            id="lastName"
            inputRef={lastNameRef}
            defaultValue={lastName}
            {...register('lastName')}
            error={'lastName' in errors}
            helperText={errors.lastName?.message as string}
            onChange={handleChangeLastName}
            label="姓"
            placeholder="中電"
            required
            variant="filled"
            fullWidth
            margin="dense"></TextField>
          <TextField
            id="firstName"
            inputRef={firstNameRef}
            {...register('firstName')}
            error={'firstName' in errors}
            helperText={errors.firstName?.message as string}
            onChange={handleChangeFirstName}
            defaultValue={firstName}
            label="名"
            placeholder="太郎"
            required
            variant="filled"
            fullWidth
            margin="dense"></TextField>
        </Stack>
        <Typography variant="subtitle1">
          <Typography component={'span'} color="red">
            *
          </Typography>
          <Typography component={'span'} sx={{ ml: 1 }}>
            お名前（かな）
          </Typography>
        </Typography>
        <Stack spacing={3} direction="row" useFlexGap>
          <TextField
            id="lastNameKana"
            inputRef={lastNameKanaRef}
            {...register('lastNameKana')}
            error={'lastNameKana' in errors}
            helperText={errors.lastNameKana?.message as string}
            onChange={handleChangeLastNameKana}
            defaultValue={lastNameKana}
            label="せい"
            placeholder="ちゅうでん"
            required
            variant="filled"
            fullWidth
            margin="dense"></TextField>
          <TextField
            id="firstNameKana"
            inputRef={firstNameKanaRef}
            {...register('firstNameKana')}
            error={'firstNameKana' in errors}
            helperText={errors.firstNameKana?.message as string}
            onChange={handleChangeFirstNameKana}
            defaultValue={firstNameKana}
            label="めい"
            placeholder="たろう"
            required
            variant="filled"
            fullWidth
            margin="dense"></TextField>
        </Stack>
        <CommonAddressForm
          label="住所自動入力"
          postalCode={postalCode}
          forms={{
            setters: {
              setPostalCode,
              setPref,
              setCity,
              setTown,
              setPlace
            },
            formDatas: {
              postalCode,
              pref,
              city,
              town,
              place
            }
          }}
        />

        <Typography variant="subtitle1">
          <Typography component={'span'} color="red">
            *
          </Typography>
          <Typography component={'span'} sx={{ ml: 1 }}>
            電話番号（半角　ハイフンあり）
          </Typography>
        </Typography>
        <Stack spacing={3} direction="row">
          <TextField
            id="phone"
            inputRef={phoneRef}
            {...register('phone')}
            error={'phone' in errors}
            helperText={errors.phone?.message as string}
            onChange={handleChangePhone}
            defaultValue={phone}
            label="電話番号（半角　ハイフンあり）"
            placeholder="例）090-1234-5678"
            required
            variant="filled"
            size={'medium'}></TextField>
        </Stack>
        <Typography variant="subtitle1">
          <Typography component={'span'} sx={{ ml: 1 }}>
            メールアドレス
          </Typography>
        </Typography>
        <Stack spacing={3} direction="row">
          <TextField
            id="email"
            inputRef={emailRef}
            {...register('email')}
            error={'email' in errors}
            helperText={errors.email?.message as string}
            onChange={handleChangeEmail}
            defaultValue={email}
            label="メールアドレス"
            value={email}
            variant="filled"
            fullWidth
            disabled></TextField>
        </Stack>
        <Typography
          component={'div'}
          variant={'subtitle2'}
          sx={{ mt: 4, mb: 1 }}>
          テラシテのご登録に際して、中部電力グループのポイントプログラム「カテエネ」にご登録頂きます。
          <br />
          以下は「カテエネ」の登録情報として利用させて頂きます。
        </Typography>
        {isEmpty(kateneId) ? (
          <>
            <Typography variant="subtitle1">
              <Typography component={'span'} color="red">
                *
              </Typography>
              <Typography component={'span'} sx={{ ml: 1 }}>
                生年月
              </Typography>
            </Typography>
            <Stack spacing={3} direction="row">
              <FormControl error={'barthYear' in errors} sx={{ width: 200 }}>
                <InputLabel id="barthYearLabel">年を選択</InputLabel>
                <Select
                  labelId="barthYearLabel"
                  id="barthYear"
                  inputRef={barthYearRef}
                  {...register('barthYear')}
                  error={'barthYear' in errors}
                  onChange={handleChangeBarthYear}
                  defaultValue={barthYear}
                  required
                  fullWidth
                  variant="filled">
                  {map((year: number) => {
                    return <MenuItem value={year.toString()}>{year}</MenuItem>
                  })(listBirthYear())}
                </Select>
                <FormHelperText>
                  {errors.barthYear?.message as string}
                </FormHelperText>
              </FormControl>
              <Typography component={'span'}>年</Typography>
              <FormControl error={'barthMonth' in errors} sx={{ width: 100 }}>
                <InputLabel id="barthMonthLabel">年を選択</InputLabel>
                <Select
                  labelId="barthMonthLabel"
                  id="barthMonth"
                  inputRef={barthMonthRef}
                  {...register('barthMonth')}
                  error={'barthMonth' in errors}
                  onChange={handleChangeBarthMonth}
                  defaultValue={barthMonth}
                  required
                  variant="filled">
                  <MenuItem value={'1'}>1</MenuItem>
                  <MenuItem value={'2'}>2</MenuItem>
                  <MenuItem value={'3'}>3</MenuItem>
                  <MenuItem value={'4'}>4</MenuItem>
                  <MenuItem value={'5'}>5</MenuItem>
                  <MenuItem value={'6'}>6</MenuItem>
                  <MenuItem value={'7'}>7</MenuItem>
                  <MenuItem value={'8'}>8</MenuItem>
                  <MenuItem value={'9'}>9</MenuItem>
                  <MenuItem value={'10'}>10</MenuItem>
                  <MenuItem value={'11'}>11</MenuItem>
                  <MenuItem value={'12'}>12</MenuItem>
                </Select>
                <FormHelperText>
                  {errors.barthMonth?.message as string}
                </FormHelperText>
              </FormControl>
              <Typography component={'span'}>月</Typography>
            </Stack>
            <Typography variant="subtitle1">
              <Typography component={'span'} color="red">
                *
              </Typography>
              <Typography component={'span'} sx={{ ml: 1 }}>
                性別
              </Typography>
            </Typography>
            <Stack spacing={3} direction="row">
              <FormControl
                error={'gender' in errors}
                sx={{ width: 200 }}
                required>
                <InputLabel id="genderLabel">性別</InputLabel>
                <Select
                  labelId="genderLabel"
                  id="gender"
                  inputRef={genderRef}
                  {...register('gender')}
                  error={'gender' in errors}
                  onChange={handleChangeGender}
                  defaultValue={gender}
                  fullWidth
                  variant="filled">
                  <MenuItem value={'male'}>男性</MenuItem>
                  <MenuItem value={'female'}>女性</MenuItem>
                  <MenuItem value={'nothing'}>回答しない</MenuItem>
                </Select>
                <FormHelperText>
                  {errors.gender?.message as string}
                </FormHelperText>
              </FormControl>
            </Stack>
            <Typography variant="subtitle1">
              <Typography component={'span'} color="red">
                *
              </Typography>
              <Typography component={'span'} sx={{ ml: 1 }}>
                ガスの種類
              </Typography>
            </Typography>
            <Stack spacing={3} direction="row">
              <FormControl error={'gas' in errors} sx={{ width: 300 }} required>
                <InputLabel id="gasLabel">ガスの種類を選択</InputLabel>
                <Select
                  labelId="gasLabel"
                  id="gas"
                  inputRef={gasRef}
                  {...register('gas')}
                  error={'gas' in errors}
                  onChange={handleChangeGas}
                  defaultValue={gas}
                  fullWidth
                  variant="filled">
                  <MenuItem value={'town'}>都市ガス</MenuItem>
                  <MenuItem value={'propane'}>プロパンガス</MenuItem>
                  <MenuItem value={'nothing'}>ガスを使用していない</MenuItem>
                </Select>
                <FormHelperText>{errors.gas?.message as string}</FormHelperText>
              </FormControl>
            </Stack>
            <Typography variant="subtitle1">
              <Typography component={'span'} sx={{ ml: 1 }}>
                カテエネメールマガジンの設定
              </Typography>
            </Typography>
            <Stack spacing={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="kateneMailMagazine"
                    inputRef={kateneMailMagazineRef}
                    {...register('kateneMailMagazine')}
                    onChange={handleChangeKateneMailMagazine}
                    value={kateneMailMagazine}
                    checked={kateneMailMagazine}
                  />
                }
                label={
                  'カテエネメルマガ：カテエネポイントがたまるコンテンツ、カテエネ会員限定の情報を月2回程度配信'
                }
              />
              <FormHelperText>
                {errors.kateneMailMagazine?.message as string}
              </FormHelperText>
              <FormControlLabel
                control={
                  <Checkbox
                    id="tokutokuMailMagazine"
                    inputRef={tokutokuMailMagazineRef}
                    {...register('tokutokuMailMagazine')}
                    // error={'tokutokuMailMagazine' in errors}
                    onChange={handleChangeTokutokuMailMagazine}
                    value={tokutokuMailMagazine}
                    disabled={!kateneMailMagazine ? true : false}
                    checked={!kateneMailMagazine ? false : tokutokuMailMagazine}
                  />
                }
                label={
                  <>
                    とくとくメルマガおトクなキャンペーンや割引・プレゼント情報をいち早くお届けします
                    <br />
                    ※とくとくメルマガを選択する際は「カテエネメルマガ」とセットでの選択となります。
                  </>
                }
              />
              <FormHelperText>
                {errors.tokutokuMailMagazine?.message as string}
              </FormHelperText>
            </Stack>
          </>
        ) : (
          <></>
        )}
        <Typography
          align="left"
          variant="h4"
          sx={{
            borderLeft: 20,
            borderBottom: 1,
            borderColor: 'orange',
            paddingLeft: 1,
            mt: 3
          }}>
          見守られる方（ご家族さま）
        </Typography>
        <Typography variant="caption">
          今回見守られる方（ご家族さま）の電気契約に関する情報をご入力ください。
        </Typography>
        <Typography variant="subtitle1">
          <Typography component={'span'} color="red">
            *
          </Typography>
          <Typography component={'span'} sx={{ ml: 1 }}>
            電気契約お客さま番号
          </Typography>
        </Typography>
        <Stack spacing={3} direction="row">
          <TextField
            id="customerNumber"
            inputRef={customerNumberRef}
            {...register('customerNumber')}
            error={'customerNumber' in errors}
            helperText={errors.customerNumber?.message as string}
            onChange={handleChangeCustomerNumber}
            value={customerNumber}
            label="電気契約お客様番号"
            placeholder="例）09012345678"
            required
            variant="filled"
            size={'medium'}
            disabled={unknownCustomerNumber}></TextField>
        </Stack>
        <FormControlLabel
          control={
            <Checkbox
              id="unknownCustomerNumber"
              inputRef={unknownCustomerNumberRef}
              {...register('unknownCustomerNumber')}
              onChange={handleChangeUnknownCustomerNumber}
              checked={unknownCustomerNumber}
            />
          }
          label="お客さま番号が分からない"
        />
        <FormHelperText>
          {errors.unknownCustomerNumber?.message as string}
        </FormHelperText>
        <Typography component={'div'} sx={{ ml: 5 }}>
          ※お客さま番号とは
          <IconButton
            onClick={handleQuestionClick}
            color="default"
            aria-label="open website">
            <QuestionMark />
          </IconButton>
        </Typography>
        <Typography variant="subtitle1">
          <Typography component={'span'} color="red">
            *
          </Typography>
          <Typography component={'span'} sx={{ ml: 1 }}>
            電気契約のお支払方法
          </Typography>
        </Typography>
        <Stack spacing={3} direction="row">
          <FormControl fullWidth>
            <InputLabel id="paymentLabel">電気契約のお支払方法</InputLabel>
            {!unknownCustomerNumber ? (
              <Select
                labelId="paymentLabel"
                id="payment"
                label="電気契約のお支払方法"
                required
                // inputRef={paymentRef}
                {...register('payment')}
                error={'payment' in errors}
                onChange={handleChangePayment}
                defaultValue={payment}>
                <MenuItem value={'credit'}>クレジットカード</MenuItem>
                <MenuItem value={'transfer'}>口座振替</MenuItem>
                <MenuItem value={'unknown'}>その他または分からない</MenuItem>
              </Select>
            ) : (
              <Select
                labelId="paymentLabel"
                id="payment"
                label="電気契約のお支払方"
                required
                // inputRef={paymentRef}
                {...register('payment')}
                error={'payment' in errors}
                onChange={handleChangePayment}
                defaultValue={payment}>
                <MenuItem value={'credit'}>クレジットカード</MenuItem>
                <MenuItem value={'transfer'}>口座振替</MenuItem>
              </Select>
            )}
            <FormHelperText>{errors.payment?.message as string}</FormHelperText>
          </FormControl>
        </Stack>
        <Box display={payment === 'unknown' ? 'none' : 'block'}>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              {payment === 'credit'
                ? 'カード番号（下4桁）'
                : '口座番号（下4桁）'}
            </Typography>
          </Typography>
          <Stack spacing={3} direction="row">
            <TextField
              id="paymentNumber"
              inputRef={paymentNumberRef}
              {...register('paymentNumber')}
              error={'paymentNumber' in errors}
              helperText={errors.paymentNumber?.message as string}
              onChange={handleChangePaymentNumber}
              defaultValue={paymentNumber}
              label={
                payment === 'credit'
                  ? 'カード番号（下4桁）'
                  : '口座番号（下4桁）'
              }
              placeholder="1234"
              required
              variant="filled"
              size={'medium'}></TextField>
          </Stack>
        </Box>
        <Box
          display={
            payment === 'unknown' || unknownCustomerNumber ? 'block' : 'none'
          }>
          <Typography
            variant="subtitle2"
            fontSize={'1.1em'}
            fontStyle={'bold'}
            color="red"
            bgcolor={'yellow'}>
            ※今回見守られる方（ご家族さま）の電気契約に関する情報を入力ください。
          </Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              電気契約名義（漢字・全角）
            </Typography>
          </Typography>
          <Stack spacing={3} direction="row">
            <TextField
              id="contractorName"
              inputRef={contractorNameRef}
              {...register('contractorName')}
              error={'contractorName' in errors}
              helperText={errors.contractorName?.message as string}
              onChange={handleChangeContractorName}
              defaultValue={contractorName}
              label="電気契約名義（漢字・全角）"
              placeholder="中電　花子"
              required
              variant="filled"
              fullWidth></TextField>
          </Stack>
          <Typography variant="subtitle1">
            <Typography component={'span'} sx={{ ml: 1 }}>
              電気契約名義（かな・全角）
            </Typography>
          </Typography>
          <Stack spacing={3} direction="row">
            <TextField
              id="contractorNameKana"
              inputRef={contractorNameKanaRef}
              {...register('contractorNameKana')}
              error={'contractorNameKana' in errors}
              helperText={errors.contractorNameKana?.message as string}
              onChange={handleChangeContractorNameKana}
              defaultValue={contractorNameKana}
              label="電気契約名義（かな・全角）"
              placeholder="ちゅうでん　はなこ"
              required
              variant="filled"
              fullWidth></TextField>
          </Stack>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              郵便番号（半角　ハイフンあり）
            </Typography>
          </Typography>
          <Stack spacing={3} direction="row">
            <TextField
              id="contractorPostalCode"
              inputRef={contractorPostalCodeRef}
              {...register('contractorPostalCode')}
              error={'contractorPostalCode' in errors}
              helperText={errors.contractorPostalCode?.message as string}
              onChange={handleChangeContractorPostalCode}
              defaultValue={contractorPostalCode}
              label="郵便番号（半角　ハイフンあり）"
              placeholder="例）123-4567"
              required
              variant="filled"
              size={'medium'}></TextField>
          </Stack>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              電話番号（半角　ハイフンあり）
            </Typography>
          </Typography>
          <Stack spacing={3} direction="row">
            <TextField
              id="contractorPhone"
              inputRef={contractorPhoneRef}
              {...register('contractorPhone')}
              error={'contractorPhone' in errors}
              helperText={errors.contractorPhone?.message as string}
              onChange={handleChangeContractorPhone}
              defaultValue={contractorPhone}
              label="電話番号（半角　ハイフンあり）"
              required
              placeholder="090-0000-0000"
              variant="filled"
              fullWidth></TextField>
          </Stack>
        </Box>
        <Typography
          align="left"
          variant="h4"
          sx={{
            borderLeft: 20,
            borderBottom: 1,
            borderColor: 'orange',
            paddingLeft: 1,
            mt: 3
          }}>
          サービス利用規約への同意
        </Typography>
        <Typography variant="caption">
          本サービスにお申込みいただくにあたり、以下の利用規約への同意が必要です。
          <br />
          お申し込みの前に必ずご確認ください。
        </Typography>
        <Stack spacing={3}>
          <Link
            to={
              'https://terashite.zendesk.com/hc/ja/articles/4494809865753-%E3%83%86%E3%83%A9%E3%82%B7%E3%83%86%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84'
            }
            target="_blank">
            テラシテサービス利用規約
          </Link>
          <FormControl error={'aggree' in errors}>
            <FormControlLabel
              control={
                <Checkbox
                  component={'span'}
                  id="aggree"
                  {...register('aggree')}
                  onChange={handleChangeAgree}
                  checked={agree}
                  required
                />
              }
              label={
                <Typography variant="caption">
                  <Typography component={'span'} color="red">
                    *
                  </Typography>
                  <Typography component={'span'} sx={{ ml: 1 }}>
                    上記の利用規約に同意します。
                  </Typography>
                </Typography>
              }
            />
            <FormHelperText>{errors.aggree?.message as string}</FormHelperText>
          </FormControl>
          <FormControl error={'covenant' in errors}>
            <FormControlLabel
              control={
                <Checkbox
                  id="covenant"
                  {...register('covenant')}
                  onChange={handleChangeCovenant}
                  checked={covenant}
                  required
                />
              }
              label={
                <Typography variant="caption">
                  <Typography component={'span'} color="red">
                    *
                  </Typography>
                  <Typography component={'span'} sx={{ ml: 1 }}>
                    私は、見守られる方（ご家族さま）にテラシテの内容を説明した上で、見守られる方（ご家族さま）の個人情報を取得すること、見守られる方（ご家族さま）の電力消費データが私に開示されることについて、同意を得ていることを誓約します。
                  </Typography>
                </Typography>
              }
            />
            <FormHelperText>
              {errors.covenant?.message as string}
            </FormHelperText>
          </FormControl>
        </Stack>
        <Divider sx={{ mt: 5, mb: 5 }} />
        <Typography variant="subtitle1">
          <Typography component={'span'} sx={{ ml: 1 }}>
            お申込みにあたり、紹介コード（半角英数字）をお持ちの方は以下にご入力をお願いします。
          </Typography>
        </Typography>
        <Stack spacing={3} direction="row">
          <TextField
            id="couponCode"
            inputRef={couponCodeRef}
            {...register('couponCode')}
            error={'couponCode' in errors}
            helperText={errors.couponCode?.message as string}
            onChange={handleChangeCuponCode}
            value={couponCode}
            label="紹介コード"
            placeholder="1234"
            variant="filled"
            size={'medium'}></TextField>
        </Stack>
      </Box>
    </Container>
  )
}
